import React from 'react';

import { ReactComponent as LightBulbIcon } from 'ui/asset/LightBulbIcon.svg';
import { CircleButton } from 'ui/component';
import classNames from './EABDKeyToSuccessCircle.module.scss';

export interface KeyToSuccessCircleProps
  extends Readonly<{
    onButtonPress: () => void;
  }> {}

export const KeyToSuccessCircle = React.memo<KeyToSuccessCircleProps>((props) => {
  const { onButtonPress } = props;

  const ContentElement = React.useMemo(() => {
    return (
      <div className={classNames.content}>
        <LightBulbIcon className={classNames.icon} />
        <p className={classNames.title}>What is the key to success?</p>
        <CircleButton arrowDirection={'right'} onPress={onButtonPress} />
      </div>
    );
  }, [onButtonPress]);

  return (
    <div className={classNames.container}>
      <div className={classNames.circle}>
        <div className={classNames.inner}>{ContentElement}</div>
      </div>
    </div>
  );
});
